<template>
    <div class="col-12 d-flex align-items-center">
        <Button icon @click="handleChangeStep('back')" class="mr-2" type="outline" :color="getPrimaryColor" :disabled="disableBackButton">
            <ArrowDropdown :rotate="90" :color="disableBackButton ? 'c-ndarkfour' : getPrimaryColorHex.four"/>
        </Button>
        <Button icon @click="handleChangeStep('next')" class="mr-3" type="outline" :color="getPrimaryColor" :disabled="disableNextButton">
            <ArrowDropdown :rotate="-90" :color="disableNextButton ? 'c-ndarkfour' : getPrimaryColorHex.four"/>
        </Button>
        <Button @click="handleSaveChange" :color="getPrimaryColor" >
            {{ `${lastStep ? 'Finalizar' : 'Salvar alteração'}` }} 
        </Button>
        <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="step == 'next' ? nextStep() : backStep()" @saveChange="handleSaveChange"/>
    </div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import CancelRegister from '@/components/modals/CancelRegister'
export default {
    components: {
        ArrowDropdown,
        CancelRegister
    },
    props: {
        disableNextButton: {
            type: Boolean,
            default: false
        },
        disableBackButton: {
            type: Boolean,
            default: false
        },
        lastStep: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            step: ''
        }
    },
    methods: {
        handleChangeStep(step) {
            if (this.$store.state.register.formIsChanged) {
                this.step = step
                this.dialogVisible = true
            } else {
                if (step == 'next') this.nextStep()
                else this.backStep()
            }
        },
        handleSaveChange() {
            this.$emit('saveChange')
        },
        nextStep() {
            this.$emit('nextStep')
        },
        backStep() {
            this.$emit('backStep')
        }
    }
}
</script>

<style>

</style>